import React from 'react'
import { hasChangedValues, getFormValue, getMergedValues } from 'tyan/public/utility'
import { useInstData } from 'tyan/public/hooks'

const BatchDataInput = props => {
	const { me } = useInstData(props, { state: { changedValues: {}, typesOfChangedValues: {} } })

	const {
		onClose, onSave, showBody: Body, showMessage: Message,
		batchEdit: { fields, allowEmpty, handleSave }
	} = props

	const handleSaveInner = () => {
		const values = getMergedValues(me)

		handleSave
			? handleSave(onSave, onClose, values, me)
			: (onSave(values, me.state.typesOfChangedValues), onClose())
	}

	const handleClose = () => {
		if (!bChanged()) {
			onClose && onClose()
			return
		}

		Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
	}

	const bChanged = () => {
		return hasChangedValues(me)
	}

	const canSave = () => {
		return allowEmpty || bChanged()
	}

	return <Body data={me} minWidth="600" maxWidth="600"
		controls={
			[
				{ _button: '确认', handler: handleSaveInner, disabled: !canSave() },
				{ _button: (bChanged() || allowEmpty) && '取消' || '关闭', icon: 'close', handler: handleClose },
			]
		}
		fieldsets={
			[
				{ title: '', _fieldset: fields },
			]}
	/>
}

export default BatchDataInput